import { render, staticRenderFns } from "./IntegrationsManagement.vue?vue&type=template&id=04a23164&scoped=true&"
import script from "./IntegrationsManagement.vue?vue&type=script&lang=js&"
export * from "./IntegrationsManagement.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsManagement.vue?vue&type=style&index=0&id=04a23164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a23164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a23164')) {
      api.createRecord('04a23164', component.options)
    } else {
      api.reload('04a23164', component.options)
    }
    module.hot.accept("./IntegrationsManagement.vue?vue&type=template&id=04a23164&scoped=true&", function () {
      api.rerender('04a23164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/IntegrationsManagement.vue"
export default component.exports